import { Button, Icon, Stack, Text, useColorModeValue } from '@ecoinvent/ui';
import { BiError } from 'react-icons/bi';

interface ErrorStateProps {
  onRetry: () => void;
  onSkip: () => void;
  allowSkip?: boolean;
}

const ErrorState = ({ onRetry, onSkip, allowSkip = true }: ErrorStateProps) => {
  const textColor = useColorModeValue('gray.500', 'gray.400');

  return (
    <Stack align="center" justify="center" spacing={6} flex={1} role="alert">
      <Icon as={BiError} boxSize={16} color="gray.400" />
      <Stack spacing={1} align="center" textAlign="center">
        <Text fontWeight="medium" color={textColor}>
          Something went wrong.
        </Text>
        <Text color={textColor}>We couldn&apos;t save your responses. Please try again.</Text>
      </Stack>
      <Stack spacing={2} w="100%" maxW="400px">
        <Button colorScheme="green" size="lg" onClick={onRetry}>
          Try Again
        </Button>
        {allowSkip && (
          <Button variant="ghost" size="sm" onClick={onSkip}>
            Skip for now
          </Button>
        )}
      </Stack>
    </Stack>
  );
};

export default ErrorState;
